<template>
  <div>
    <PageBanner title="产品介绍" subtitle="高性价比产品，让您买的放心" />
    <section class="page-section">
      <b-tabs content-class="mt-4 product-tabs" fill>
        <b-tab title="全部" active>
          <ProductGrid :list="proList" @select="goProdetail" />
        </b-tab>
        <b-tab title="喷淋塔">
          <ProductGrid :list="spList" @select="goProdetail" />
        </b-tab>
        <b-tab title="滴滤塔">
          <ProductGrid :list="filterList" @select="goProdetail" />
        </b-tab>
        <b-tab title="水帘柜">
          <ProductGrid :list="sprayList" @select="goProdetail" />
        </b-tab>
        <b-tab title="除尘器">
          <ProductGrid :list="dust" @select="goProdetail" />
        </b-tab>
        <b-tab title="活性炭">
          <ProductGrid :list="carbon" @select="goProdetail" />
        </b-tab>
        <b-tab title="催化燃烧">
          <ProductGrid :list="bcoList" @select="goProdetail" />
        </b-tab>
        <b-tab title="过滤器">
          <ProductGrid :list="dryfilter" @select="goProdetail" />
        </b-tab>
      </b-tabs>
    </section>
  </div>
</template>

<script>
import { PRODUCT_LIST } from '@/constants/staticData'
import PageBanner from '@/components/PageBanner.vue'
import ProductGrid from '@/components/ProductGrid.vue'

export default {
  name: 'ProductsView',
  components: { PageBanner, ProductGrid },
  data () {
    return {
      proList: [],
      spList: [],
      sprayList: [],
      filterList: [],
      dust: [],
      carbon: [],
      dryfilter: [],
      bcoList: []
    }
  },
  created () {
    this.getProList()
  },
  methods: {
    getProList () {
      this.proList = PRODUCT_LIST
      this.spList = this.proList.filter(item => item.name.indexOf('喷淋塔') !== -1)
      this.filterList = this.proList.filter(item => item.name.indexOf('滴滤塔') !== -1)
      this.dust = this.proList.filter(item => item.name.indexOf('除尘器') !== -1)
      this.carbon = this.proList.filter(item => item.name.indexOf('活性炭') !== -1)
      this.dryfilter = this.proList.filter(item => item.name.indexOf('过滤器') !== -1)
      this.bcoList = this.proList.filter(item => item.name.indexOf('催化燃烧') !== -1)
      this.sprayList = this.proList.filter(item => item.name.indexOf('水帘柜') !== -1)
    },
    goProdetail (id) {
      this.$router.push({ path: `/prodetail/${id}` })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .product-tabs .nav-link {
  color: var(--color-text);
  font-size: 0.9375rem;
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;

  &.active {
    color: #fff;
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }
}
</style>
